/**
 * Spanish Test Definitions
 *
 * All psychometric tests in Spanish language.
 * This is the default/original language version.
 */

import { TestDefinition } from '../../types';
import { TESTS_DEPRESION } from './depresion';
import { TESTS_ANSIEDAD } from './ansiedad';
import { TESTS_BIPOLARIDAD } from './bipolaridad';
import { TESTS_TRAUMA } from './trauma';
import { TESTS_ADICCIONES } from './adicciones';
import { TESTS_RIESGO_SUICIDA } from './riesgo-suicida';
import { TESTS_PSICOSIS } from './psicosis';
import { TESTS_FUNCIONALIDAD } from './funcionalidad';
import { TESTS_PEDIATRICO_TDAH } from './pediatrico-tdah';
import { TESTS_PERSONALIDAD } from './personalidad';
import { TESTS_DISCAPACIDAD } from './discapacidad';
import { TESTS_TOC } from './toc';
import { TESTS_ALIMENTARIOS } from './alimentarios';
import { TESTS_ESTRES } from './estres';
import { TESTS_CALIDAD_VIDA } from './calidad-vida';
import { TESTS_TDAH_ADULTOS } from './tdah-adultos';
import { TESTS_16_PERSONALITY } from './personalidad-16pf';

export const TEST_DEFINITIONS: TestDefinition[] = [
  ...TESTS_DEPRESION,
  ...TESTS_ANSIEDAD,
  ...TESTS_BIPOLARIDAD,
  ...TESTS_TRAUMA,
  ...TESTS_ADICCIONES,
  ...TESTS_RIESGO_SUICIDA,
  ...TESTS_PSICOSIS,
  ...TESTS_FUNCIONALIDAD,
  ...TESTS_PEDIATRICO_TDAH,
  ...TESTS_TDAH_ADULTOS,
  ...TESTS_PERSONALIDAD,
  ...TESTS_16_PERSONALITY,
  ...TESTS_DISCAPACIDAD,
  ...TESTS_TOC,
  ...TESTS_ALIMENTARIOS,
  ...TESTS_ESTRES,
  ...TESTS_CALIDAD_VIDA
];

// Re-export individual category arrays for flexibility
export {
  TESTS_DEPRESION,
  TESTS_ANSIEDAD,
  TESTS_BIPOLARIDAD,
  TESTS_TRAUMA,
  TESTS_ADICCIONES,
  TESTS_RIESGO_SUICIDA,
  TESTS_PSICOSIS,
  TESTS_FUNCIONALIDAD,
  TESTS_PEDIATRICO_TDAH,
  TESTS_TDAH_ADULTOS,
  TESTS_PERSONALIDAD,
  TESTS_16_PERSONALITY,
  TESTS_DISCAPACIDAD,
  TESTS_TOC,
  TESTS_ALIMENTARIOS,
  TESTS_ESTRES,
  TESTS_CALIDAD_VIDA
};
